import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProductTypes } from "src/app/shared/product/productTypes";
import { ViewProductInfoHandlerService } from "../../../buyer/services/view-product-info-handler.service";
import { ProductsSearchService } from "../../services/products-search.service";

@Component({
  selector: 'app-products-search',
  templateUrl: './products-search.component.html',
  styleUrls: ['./products-search.component.scss']
})
export class ProductsSearchComponent implements OnInit {
  products: any;

  constructor(
    private route: ActivatedRoute,
    private ProductsSearch: ProductsSearchService,
    private vpihs: ViewProductInfoHandlerService
  ) { }

  async ngOnInit() {
    if (!this.vpihs.exchangeRates) {
      await this.vpihs.getExchangeRates();
    }
    this.route.paramMap.subscribe(async params => {
      await this.getSearchResults(params.get("searchWord") as string);
    });
  }

  async getSearchResults(searchWord: string) {
    this.ProductsSearch.setParams({ searchWord });
    let result = await this.ProductsSearch.make();
    this.products = result.products.map((product: any) => {
      switch (product.productType) {
        case "Event":
          product.productType = "Event";
          break;
          case "Reservation":
            product.productType = ProductTypes.Reservation;
          break;
        case "Physical Product":
          product.productType = "Product";
          break;
        case "Invoice":
          product.productType = "Invoice";
          break;
      }
      if (product.productPrice) {
        product.productPrice = this.vpihs
          .getExchangedValue(+product.productPrice, product.currency)
          .toFixed(2);
      }

      return product;
    });
    console.log('products', this.products);
  }
}
